import { render } from "./collapse.vue?vue&type=template&id=06da72b4&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=06da72b4&scoped=true&lang=css"

import exportComponent from "/Users/projects/crud/liderombor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06da72b4"]])

export default __exports__